/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import "./App.css";

function App() {
  const [loaded, setloaded] = useState(false);
  const isMounted = useRef(false);

  const [loadedWidgets, setLoadedWidgets] = useState([]);
  const url =
    "https://wscc-usertask-service-dev.wscc-dev-dmz.prj.gcp.wellsky.io/index.js";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => {
      setloaded(true);
    };
    document.body.appendChild(script);
    isMounted.current = true;

    //unmount - ondestory
    return () => {
      setloaded(false);
      setTimeout(() => {
        document.body.removeChild(script);
      }, 500);
    };
  }, [url]);

  useEffect(() => {
    if (loaded) {
      const widget = new UserTasksWidget({
        mount: "usertasks",
        widget: "USERTASKS",
        widgetSettings: {
          token:
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfaWQiOiJ3c2NjLnFhLmF1dG9tYXRpb24iLCJ0ZW5hbnRfaWQiOiJPUkctQXV0b21hdGlvbi1vcmcxIiwidXNlcl9pZCI6IlVTRVItNDA4MjI0NTYtMmU2OS00OTEyLWJlNDAtZjgyOTYxN2NmZTYyIiwicm9sZXMiOlsiVklFV0VSIiwiRURJVE9SIiwiTUFOQUdFIl0sInNjb3BlIjpbIlVTRVIiLCJBUFBBRE1JTiIsIlRFTkFOVEFETUlOIl0sImlhdCI6MTcxNDE0ODU1NH0.tZmyqXtEMX9az29f4xwcy8qz1VMyvHzWzaQj3N1wnbE",
          endPoint:
            "https://usertask-service-grapql-vitumuotya-uk.a.run.app/graphql",
          hideTabs: false,
          hideFilter: false,
          organizationId: "ORG-Automation-org1",
          appId: "wscc.qa.automation",
          /*  
          environment:"qa",
          appsyncGraphqlEndpoint:"https://cf-api-lb4cqj4ohq-uk.a.run.app/graphql"
          customFormsUrl:"https://www.wscc.qa.wellsky.io/cfp_gcp/qa/widgets/formsWidgetsNG.js?uuid=abd288f9-63df-4d0a-9bd0-47d6d783ff39",
          customFormsToken:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfaWQiOiI0QmdXWnJOWTR6NSIsInRlbmFudF9pZCI6Ik9SRy1mY2MxNjM0My0yOTE2LTQyNjUtYmVmNS0yZjdjYmExMWQ4M2YiLCJ0ZW5hbnRfaWRzIjpbXSwiYXV0aGRfdGVuYW50X2lkcyI6WyIxNjY5Il0sIndyaXRlX29wX3RlbmFudF9pZHMiOltdLCJ1c2VyIjp7ImlkIjoiVVNFUi0zMWYzYjYwZC00YmUwLTQ5Y2ItYTUxNS00NmI2ZGRhNjY5YTIiLCJlbWFpbCI6InN1cnlha2FudC5kZXZrYXJAd2VsbHNreS5jb20iLCJmdWxsX25hbWUiOiJTdXJ5YWthbnQgRGV2a2FyIiwibmFtZSI6IlN1cnlha2FudCBEZXZrYXIiLCJyb2xlcyI6WyJSRUdJU1RFUkVEX1VTRVIiLCJBUFBfQURNSU4iLCJURU5BTlRfQURNSU4iXX0sImlhdCI6MTcyMDY5MjU2MH0.z7x_Axz0dz9vNCfF2ry_YZZqOOpBXpMx83V84c0H2Ew",
          */
          environment: "dev",
          appsyncGraphqlEndpoint:"https://cf-api-vitumuotya-uk.a.run.app/graphql",
          customFormsToken:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfaWQiOiI0QmdXWnJOWTR6NSIsInRlbmFudF9pZCI6Ik9SRy1mNjc4YzJlMy1mMDk0LTQ1MjEtYjNjYi1kYmNkMjlhMDk0MTEiLCJ0ZW5hbnRfaWRzIjpbXSwiYXV0aGRfdGVuYW50X2lkcyI6WyIxNjY5Il0sIndyaXRlX29wX3RlbmFudF9pZHMiOltdLCJ1c2VyIjp7ImlkIjoiVVNFUi05NzdkNWQwMS05YzNjLTRkYjgtODBkMi02MmZkMWExYjNiNjgiLCJlbWFpbCI6InN1cnlha2FudC5kZXZrYXJAd2VsbHNreS5jb20iLCJmdWxsX25hbWUiOiJTdXJ5YWthbnRfMiIsIm5hbWUiOiJTdXJ5YWthbnRfMiIsInJvbGVzIjpbIlJFR0lTVEVSRURfVVNFUiIsIkFQUF9BRE1JTiIsIlRFTkFOVF9BRE1JTiJdfSwiaWF0IjoxNzE5NTA5MDQ3fQ.H6uBtIgdaj-k9eMDNIjeKcN2iyREb8QLY8igsyD7x4c",
          customFormsUrl: "https://www.wscc.dev.wellsky.io/cfp_gcp/dev/widgets/formsWidgetsNG.js?uuid=432997b4-3d44-4b62-b369-2e6170c6534c",
        },
        taskConfig: {
          id: null,
        },
      });
      const newwidgets = loadedWidgets;
      newwidgets.push(widget);
      setLoadedWidgets(newwidgets);
    }
    return () => {
      if (loadedWidgets.length > 0) {
        loadedWidgets.forEach((widget) => widget.unmount());
      }
    };
  }, [loaded]);

  return <div id="usertasks" style={{ width: "100%", height: "100%" }}></div>;
}

export default App;
